var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input__container"},[_c('p',[_vm._v(_vm._s(_vm.scrollingText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }